<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.orderNo"
        placeholder="提现订单号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="提现状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in applyStatus"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        startPlaceholder="申请开始时间"
        endPlaceholder="申请截止时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        v-if="
          (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
        @click="handleExport"
        >导出</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        label="提现订单号"
        align="center"
        prop="orderNo"
      ></el-table-column>
      <el-table-column
        label="提现金额(¥)"
        align="center"
        prop="amount"
      ></el-table-column>
      <el-table-column label="提现状态" align="center" prop="status">
        <template slot-scope="scope">
          {{ getStatus(scope.row.status) }}
        </template>
      </el-table-column>

      <el-table-column label="打款凭证" align="center" prop="logo">
        <template slot-scope="scope">
          <el-image
            :src="getTableThumbnailImg(scope.row.imgUrl)"
            fit="cover"
            v-if="scope.row.imgUrl"
            :preview-src-list="[scope.row.imgUrl]"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column
        label="备注"
        align="center"
        prop="remark"
      ></el-table-column>

      <el-table-column
        label="收款方式"
        align="center"
        prop="bankName"
      ></el-table-column>
      <el-table-column label="申请时间" align="center" prop="ctdate">
        <template slot-scope="scope">
          {{ scope.row.ctdate | parseTime }}
        </template>
      </el-table-column>

      <el-table-column label="状态变更时间" align="center" prop="mddate">
        <template slot-scope="scope">
          {{ scope.row.mddate | parseTime }}
        </template></el-table-column
      >

      <el-table-column
        label="操作"
        align="center"
        width="100"
        class-name="small-padding fixed-width"
        v-if="
          (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="onCancel(scope.row)"
            v-if="scope.row.status == 0"
            >取消</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout=" prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getTableThumbnailImg } from "@/utils/utils";
import { getLogionUserInfo } from "@/utils/auth";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
import { uploadXlsx } from "@/utils/index";
import {
  getWithdrawApplyList,
  exportAgentProfitList,
  cancelWithdrawApply,
} from "@/api/account-profit";
import DataPicker from "@/views/components/dataPicker.vue";

const APPLY_STATUS = [
  { key: 0, value: "提现待审核" },
  { key: 1, value: "提现成功" },
  { key: 2, value: "提现失败" },
  { key: 3, value: "取消" },
];

export default {
  name: "withdrawalRecords",
  props: {
    agentUserId: {
      type: Number || String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        pageSize: 10,
        orderNo: "",
        status: null,
        startTime: "",
        endTime: "",
      },
      applyStatus: APPLY_STATUS,
      statusMap: new Map(APPLY_STATUS.map((item) => [item.key, item.value])),
      isAgentLogin: "",
    };
  },
  created() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.getList();
  },
  filters: {
    parseTime(time) {
      const date = new Date(time);
      return date.toLocaleString("zh-CN");
    },
  },
  methods: {
    getTableThumbnailImg,
    getList() {
      this.listLoading = false;

      this.listQuery.agentUserId = this.agentUserId;
      console.log("分润list", this.listQuery);
      getWithdrawApplyList(this.listQuery).then((res) => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        console.log("分润list-1", res, this.list);
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    onCancel(row) {
      console.log(row);
      this.$confirm("确定要取消该提现吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        cancelWithdrawApply({ id: row.id, state: 0 }).then((res) => {
          console.log(res);
          this.getList();
        });
      });
    },
    handleExport() {
      exportAgentProfitList(this.listQuery).then((res) => {
        console.log(res);
        uploadXlsx(res, "提现记录表");
      });
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      this.listQuery.startTime = value[0];
      this.listQuery.endTime = value[1];
    },
    getStatus(key) {
      return this.statusMap.get(key);
    },
  },
  computed: {
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    },
  },
  components: {
    DataPicker,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-image {
  width: 40px;
  height: 40px;
}
</style>
